/* CUSTOM_CARRIERPHONES_BY_CLAUDE (ONYX 9874f107a324, Ryan 2026-10-07)
   ─────────────────────────────────────────────────────────────────────────────
   Settings -> Admin: Freight Carrier Phone Numbers - the JS half. Markup in
   snippets/rep-settings-carrier-phones.liquid (which also loads this file, so the section at its
   256 KB cap gains one render line).

   GET /carrier-phones paints the list (defaults + saved rows, the worker says which); POST
   /carrier-phone saves a row or removes a saved one. Save stays disabled until the list loaded, so a
   failed read never looks like an empty list. Every row is re-read from the server after a write. */
(function () {
  'use strict';

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) { if (el) el.className = 'rep-settings__message'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var list = document.getElementById('settings-carrierphones-list');
    var carrier = document.getElementById('settings-carrierphones-carrier');
    var phone = document.getElementById('settings-carrierphones-phone');
    var label = document.getElementById('settings-carrierphones-label');
    var note = document.getElementById('settings-carrierphones-note');
    var btn = document.getElementById('settings-carrierphones-btn');
    var msg = document.getElementById('settings-carrierphones-msg');
    if (!list || !btn) return;

    function paint(rows) {
      var h = '<table style="width:100%;border-collapse:collapse;">'
        + '<thead><tr style="text-align:left;background:var(--rq-bg-subtle,#f6f7f9);">'
        + '<th style="padding:6px 8px;">Carrier</th><th style="padding:6px 8px;">Phone</th><th style="padding:6px 8px;">Number word</th><th style="padding:6px 8px;">Source</th><th></th></tr></thead><tbody>';
      rows.forEach(function (r) {
        var src = r.origin === 'saved'
          ? 'saved' + (r.setBy ? ' by ' + esc(r.setBy) : '') + (r.setAt ? ' ' + esc(String(r.setAt).slice(0, 10)) : '')
          : 'researched' + (r.verified ? '' : ' (check)');
        h += '<tr style="border-top:1px solid var(--rq-border,#e5e7eb);">'
          + '<td style="padding:6px 8px;"><a href="#" data-cp-edit="' + esc(r.carrier) + '" style="color:inherit;">' + esc(r.carrier) + '</a>'
          + (r.aliases && r.aliases.length ? '<div style="font-size:11px;color:var(--rq-text-secondary);">also ' + esc(r.aliases.join(', ')) + '</div>' : '') + '</td>'
          + '<td style="padding:6px 8px;white-space:nowrap;">' + esc(r.phoneDisplay || 'none') + (r.phoneNote ? '<div style="font-size:11px;color:var(--rq-text-secondary);">' + esc(r.phoneNote) + '</div>' : '') + '</td>'
          + '<td style="padding:6px 8px;">' + esc(r.numberLabel || 'tracking') + '</td>'
          + '<td style="padding:6px 8px;font-size:12px;">' + (r.source && /^https?:/.test(r.source) ? '<a href="' + esc(r.source) + '" target="_blank" rel="noopener">' + src + '</a>' : src) + '</td>'
          + '<td style="padding:6px 8px;">' + (r.origin === 'saved' ? '<button type="button" data-cp-remove="' + esc(r.carrier) + '" style="font-size:12px;">Remove</button>' : '') + '</td>'
          + '</tr>';
      });
      list.innerHTML = h + '</tbody></table>';
      list.__rows = rows;
    }

    function load() {
      return window.RepPortal.API.get('/carrier-phones').then(function (data) {
        paint((data && data.rows) || []);
        btn.disabled = false;
      }).catch(function () {
        list.innerHTML = '<p style="padding:8px;color:#b91c1c;">Could not read the carrier list - reload the page before saving.</p>';
      });
    }
    load();

    list.addEventListener('click', function (e) {
      var ed = e.target.closest && e.target.closest('[data-cp-edit]');
      if (ed) {
        e.preventDefault();
        var row = (list.__rows || []).filter(function (r) { return r.carrier === ed.getAttribute('data-cp-edit'); })[0];
        if (row) { carrier.value = row.carrier; phone.value = row.phoneDisplay || ''; label.value = row.numberLabel || ''; note.value = row.phoneNote || ''; phone.focus(); }
        return;
      }
      var rm = e.target.closest && e.target.closest('[data-cp-remove]');
      if (!rm) return;
      var name = rm.getAttribute('data-cp-remove');
      if (!window.confirm('Remove the saved number for ' + name + '? The researched default (if any) comes back.')) return;
      hideMsg(msg);
      window.RepPortal.API.post('/carrier-phone', { carrier: name, remove: true }).then(function (res) {
        showMsg(msg, res && res.removed ? 'Removed the saved number for ' + name + '.' : ((res && res.detail) || 'Nothing to remove.'), 'success');
        return load();
      }).catch(function (err) { showMsg(msg, 'Could not remove: ' + ((err && err.message) || 'error'), 'error'); });
    });

    btn.addEventListener('click', function () {
      hideMsg(msg);
      var body = { carrier: String(carrier.value || '').trim(), phone: String(phone.value || '').trim() };
      if (!body.carrier || !body.phone) { showMsg(msg, 'Carrier and phone are both needed.', 'error'); return; }
      if (String(label.value || '').trim()) body.numberLabel = String(label.value).trim();
      body.phoneNote = String(note.value || '').trim();
      btn.disabled = true;
      window.RepPortal.API.post('/carrier-phone', body).then(function (res) {
        showMsg(msg, (res && res.detail) || 'Saved.', 'success');
        carrier.value = ''; phone.value = ''; label.value = ''; note.value = '';
        return load();
      }).catch(function (err) {
        showMsg(msg, 'Could not save. ' + ((err && err.message) || ''), 'error');
      }).then(function () { btn.disabled = false; });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
